/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'
import { range } from '~bookwormgb/util/range'

/**
 * WordPress dependencies
 */
import { 
	Fragment,
} from '@wordpress/element'

class AuthorsPlaceholder extends Component {

	render() {
		const {
			design= 'basic',
			enableCarousel,
			limit =5,
			columns = 5,
			xlColumns,
			lgColumns,
			mdColumns,
			smColumns,
			showImage = true,
			showName = true,
			showBook = true,
			enableFilters = true
		} = this.props

		let imageSize = '200px'

		if ( enableCarousel ) {
			imageSize = '142px'
		}

		let output = ''

		switch ( design ) {
			case 'basic':
				output = (
					<Fragment>
						{ ( ! enableCarousel && enableFilters ) &&
							<div className="authors-placeholder d-flex justify-content-between list-inline cbp-l-filters-alignRight cbp-l-filters-alignRight__custom text-left pt-4 pt-lg-8 mb-5 mb-lg-8 overflow-auto">
								<div className="progress bg-light w-100" style={ { height:'32px' } }></div>
							</div>
						}
						<div className={ classnames( [
								'row',
								'authors',
								'authors-placeholder',
							], { 
								'overflow-hidden flex-nowrap' : enableCarousel,
								[ `row-cols-${ smColumns } row-cols-md-${ mdColumns } row-cols-lg-${ lgColumns } row-cols-xl-${ xlColumns }` ] : enableCarousel,
								[ `row-cols-md-3 row-cols-lg-${ columns }` ] : ! enableCarousel,
							} ) }
						>
							{ range( 1, limit + 1 ).map( i => {
								return(
									<div className="author col thumbnail-item mb-7" key={ i }>
										<div className="thumbnail-caption">
											{ showImage &&
												<div className="mx-auto rounded-circle mb-5" style={ { 
													height: imageSize, width: imageSize, 'backgroundColor': '#f8f9fa', 'marginBottom': '10px' 
												} }></div>
											}
											<div className="thumbnail-body">
												{ showName && 
													<div className="progress bg-light mb-2 w-60 mx-auto"></div>
												}
												{ showBook &&
													<div className="progress bg-light w-80 mx-auto"></div>
												}
											</div>
										</div>
									</div>
								)
							} ) }
						</div>
					</Fragment>
				)
			break

			case 'horizontal':
				output = (
					<div className={ classnames( [
						'authors-list', 
						'horizontal',
						'border',
						'px-4',
						'pt-4',
						'authors-placeholder'
					], {} ) }>
						{ range( 1, limit + 1 ).map( i => {
							return(
								<div className="media mb-3 align-items-center" key={ i }>
									{ showImage &&
										<div className="thumbnail-caption">
											<div className="mx-auto rounded-circle" style={ { 
												height:'80px', width: '80px', 'backgroundColor': '#f8f9fa', 'marginBottom': '10px'
											} }></div>
										</div>
									}
									
									<div className="media-body ml-3 pl-1">
										{ showName && 
											<div className="progress bg-light mb-2"></div>
										}

										{ showBook &&
											<div className="progress bg-light"></div>
										}
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break
		}

		return output
	}
}

export default AuthorsPlaceholder